export default "__VITE_ASSET__YQ7VkaLi__"